export default {
  methods: {
    showNotification({ group, title, type }) {
      this.$notify({
        group,
        title,
        type,
        duration: 3000,
        position: 'bottom center'
      });
    },
    hideNotification({ group }) {
      this.$notify({ group, clean: true });
    }
  }
};
